import { Avatar } from "@mui/material";
import React from "react";

const ProfileDetails = ({ authUser }) => {
  return (
    <div className="flex gap-[15px] border-b p-[20px] pt-0">
      {/* Profile Pic */}
      <div>
        <Avatar
          alt="profile-pic"
          src={authUser.photo}
          className="bg-primary !h-[55px] !w-[55px]"
        />
      </div>

      {/* Detail  */}
      <div className="grid">
        <span className="text-[18px] font-medium text-gray-600">
          {authUser.fullName} | {authUser?.userRole}
        </span>
        <div className="flex gap-2 text-[14px]">
          <span className="font-bold text-gray-500">
            Username: {authUser.username}
          </span>
          |
          <a
            href={`mailto:${authUser.email}`}
            className="text-primary hover:underline"
          >
            ✉️ {authUser.email}
          </a>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
